import bizNodeModel from '../../bizNodeModel.mjs'
import DemoType from './DemoType.mjs'
import PageType from './PageType.mjs'
import UvType from './UvType.mjs'

export default bizNodeModel({
    demoType: {
        disabled: (map, node) => node.data.pkid,
        name: () => '界面视图类型',

        readableValue: (map, node) => {
            const {demoType} = node.data

            if (demoType) {
                const match = DemoType.find(e => demoType === e[0])

                if (match) {
                    return match[1]
                }
            }

            return ''
        },

        required: () => true,
    },

    memo: {
        name: () => '备注',
    },

    pageType: {
        hidden: (map, node) => 'DEMO' !== node.data.demoType,
        name: () => '页面类型',

        readableValue: (map, node) => {
            const {pageType} = node.data

            if (pageType) {
                const match = PageType.find(e => pageType === e[0])

                if (match) {
                    return match[1]
                }
            }

            return ''
        },

        required: () => true,
    },

    uvName: {
        name: () => '界面视图名称',
        required: () => true,
    },

    uvType: {
        disabled: (map, node) => node.data.pkid,
        hidden: (map, node) => 'DEMO' !== node.data.demoType,
        name: () => '终端类型',

        readableValue: (map, node) => {
            const {uvType} = node.data

            if (uvType) {
                const match = UvType.find(e => uvType === e[0])

                if (match) {
                    return match[1]
                }
            }

            return ''
        },

        required: () => true,
    },

    uvUserCode: {
        name: () => '界面视图代码',
    },
})
